module.exports = __webpack_public_path__ + "img/img5.b4d3931e.svg";